module.exports = __webpack_public_path__ + "static/favicon-test-a1a6cd7917dd7c972ce196e76010eeab.png";